import { render, staticRenderFns } from "./StaffChargeDetails.vue?vue&type=template&id=8f487604"
import script from "./StaffChargeDetails.vue?vue&type=script&lang=js"
export * from "./StaffChargeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports